<template lang="pug">
.dawn-page-section(:endpoint='$parent.$attrs.endpoint' :class='{ "wide row no-flex": wide, "no-title": !title, "full-width": fullWidth }')
  input.dummy
  .title-area(:class='{ "col-md-4": wide && title && !fullWidth }')
    h1.page-title(:class='{ "no-title": !title }') {{ title }}
    p.page-subtitle(v-if='subtitle') {{ subtitle }}
    .description(v-if='$slots.description')
      slot(name='description')
  .page-section-main(:class='[offset, wide ? title ? fullWidth || "col-md-8" : "col-md-12" : ""]')
    slot
</template>

<script>

export default {
  name: 'ed-section',
  props: {
    title: String,
    subtitle: String,
    wide: Boolean,
    fullWidth: Boolean
  },
  computed: {
    offset: function() { return `col-md-offset-${this.$attrs.offset}` }
  },
  mounted() {
    document.querySelector('.dummy').focus()
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.dummy {
  background: $canvas;
  height: 1px;
  width: 1px;
  padding: 0;
  margin: 0;
  overflow: hidden;
  outline: none;
  border: none;
  display: block;
}

.dawn-page-section:not(.wide) {
  margin: 1em 0em;
}

.dawn-page-section.dawn-page-section.dawn-page-section {

  &.white.active {
    padding: 0;
    background: #fff;

    .page-section-main {
      margin-top: -20px;
    }
  }
  
  &.no-margin.wide {
    margin-top: 0;
  }

  .page-section-main .row.row.row[class] {
    margin-left: -30px;
    margin-right: -30px;
  }
  &.row .page-section-main .row.row.row[class] {
    //margin-left: -15px;
    //margin-right: -15px;
  }

  h1.page-title {
    font-size: 1.1em;
    margin-bottom: 1em;
    @include theme {
    color: v(border);
    }

    &.no-title {
      margin-bottom: 0;
    }
  }
  @include theme {
  background: v(background-light);
  }
  opacity: .5;
  padding: 1em;

  &.ed-section {
    @include theme {
    background: v(canvas);
    }
  }

  h5.section-title,
  .section-title .h5 {
    margin-top: 0;
    transform: rotate(.03deg); // soften font a bit
  }
  .section-title .h5 {
    display: inline-block;
    font-size: 1.2rem;
    display: inline-block;
    margin: 0;
  }

  .description {
    font-size: $font-size-base-sm;
    @include theme {
      color: v(ink);
    }
    padding-right: 5em;
  }

  &.no-pad {
    padding: 0;
    margin: 0;
  }
  &.pad {
    padding: 0 .5em 1em;
    margin-bottom: 0px;
    margin-top: 0px;

    .section-title {
      margin-top: 20px;
      display: inline-block;
      width: 100%;

      font-size: $font-size-large;
      font-weight: $font-weight-normal;
      padding-left: 15px;
      padding-right: 15px;
      margin-bottom: 4px;

      @include theme {
      color: v(border);
      }

      .small {
        font-size: $font-size-xsmall;
        line-height: 2.5em;
      }
    }
  }

  .table tr {
    @include theme {
    background: v(canvas);
    }
  }

  i.success {
    display: inline-block;
    @include fa-complete;
  }

  &.active {
    opacity: 1;
  }

  &.no-flex {
    .page-title {
      //margin: 0;
    }
    .page-section-main {
      display: block;
    }
  }
  .page-section-main {
    display: flex;
    flex-wrap: wrap;
    //justify-content: center;

    p {
      width: 100%;
      line-height: 1.2em;
      margin-bottom: 1em;
    }
  }

  // wide
  &.wide {
    opacity: 1;
    padding: 0;
    margin-top: 2em;
    @include theme {
      border-bottom: 1px solid v(background-light);
      background: v(canvas);
    }

    &.full-width {
      @include theme {
        border-bottom: none;
      }
    }

    &.no-border {
      border: 0;
    }

    &.no-title {
      margin-top: 0;

      .section-title,
      .page-section-main > .col-md-12 {
        padding: 0;
      }
    }

    .title-area {
      padding: 0;
    }
    .page-title {
      margin-top: 0;
      margin-bottom: 0.5em;
      transform: rotate(0.03deg); // soften font a bit
      font-weight: $font-weight-extra-bold;
      @include theme {
        color: v(ink);
      }
    }

    .page-section-main {
      padding: 0;
      margin-bottom: 35px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/core/components/edSection/index.vue